<div class="breadcrumb">
  <span><a [routerLink]="['home/dashboard']">Dashboard</a></span>
  <mat-icon>keyboard_arrow_right</mat-icon>
  <span >
  <a [routerLink]="['/home/users']">Users</a>
</span>
  <mat-icon>keyboard_arrow_right</mat-icon>
  <span class="current">User Details</span>
</div>

<!-- User Information Section -->
<div class="user-info-section">
  <div class="section-header">
    <h3>USER INFORMATION</h3>
  </div>
  <div class="user-info-content">
    <div class="info-row">
      <div class="info-item">
        <label>Full Name</label>
        <span class="colon">:</span>
        <span class="value">{{ user()?.firstName }} {{user()?.lastName}}</span>
      </div>
      <div class="info-item">
        <label>Contact No</label>
        <span class="colon">:</span>
        <span class="value">{{ user()?.phoneNumber }}</span>
      </div>
    </div>
    <div class="info-row">
      <div class="info-item">
        <label>City</label>
        <span class="colon">:</span>
        <span class="value">{{ user()?.city }}</span>
      </div>
      <div class="info-item">
        <label>Last Session</label>
        <span class="colon">:</span>
        <span class="value">{{ userInfo.lastSession }}</span>
      </div>
    </div>
  </div>
</div>

<!-- Vehicle Information Section -->
<div class="vehicle-info-section">
  <div class="section-header">
    <h3>VEHICLE INFORMATION</h3>
  </div>
</div>

<!-- Scrollable vehicles container -->
<div class="vehicles-scroll-container">
  <!-- Loop through all vehicles -->

  @if(!user()?.vehicles || user()?.vehicles?.length === 0) {
    <div class="empty-state">
      <mat-icon>directions_car</mat-icon>
      <p>No vehicle is Registered</p>
    </div>
  }


  @for (vehicle of user()?.vehicles; track vehicle.id; let i = $index) {
    <div class="vehicle-wrapper">
      <div class="vehicle-details-container">
        <div class="header" [ngClass]="vehicle.status.toLowerCase()">
          <h2>Vehicle {{ i + 1 }}</h2>
          <div class="status-badge">
            <div [ngClass]="getStatusClass(vehicle.status)">
              <span>{{ vehicle.status }}</span>
            </div>
            <div class="edit-controls">
              @if (!editModeMap[vehicle.id]  && vehicle.status!= UserStatus.REJECTED) {
                <mat-icon class="edit-icon" (click)="toggleEditMode(vehicle.id)">edit</mat-icon>
              } @else if(vehicle.status!= UserStatus.REJECTED){
                <mat-icon class="save-icon" (click)="toggleEditMode(vehicle.id)">check_circle</mat-icon>
                <mat-icon class="cancel-icon" (click)="cancelEditMode(vehicle.id)">cancel</mat-icon>
              }
            </div>
          </div>
        </div>
        <div class="content-wrapper">
          <div class="details-section">
            <div class="detail-row">
              <label>Vehicle Company Name</label>
              <span class="colon">:</span>
              @if (!editModeMap[vehicle.id]) {
                <span class="value">{{ vehicle.vendor }}</span>
              } @else {
                @if (editedVehicles[vehicle.id]) {
                  <input
                    type="text"
                    class="edit-input"
                    [value]="editedVehicles[vehicle.id].vendor"
                    (input)="updateVehicleField(vehicle.id, 'vendor', $event)"
                  />
                }
              }
            </div>
            <div class="detail-row">
              <label>Model Name</label>
              <span class="colon">:</span>
              @if (!editModeMap[vehicle.id]) {
                <span class="value">{{ vehicle.model }}</span>
              } @else {
                @if (editedVehicles[vehicle.id]) {
                  <input
                    type="text"
                    class="edit-input"
                    [value]="editedVehicles[vehicle.id].model"
                    (input)="updateVehicleField(vehicle.id, 'model', $event)"
                  />
                }
              }
            </div>
            <div class="detail-row">
              <label>VIN</label>
              <span class="colon">:</span>
              @if (!editModeMap[vehicle.id]) {
                <span class="value">{{ vehicle.vin }}</span>
              } @else {
                @if (editedVehicles[vehicle.id]) {
                  <input
                    type="text"
                    class="edit-input"
                    [value]="editedVehicles[vehicle.id].vin"
                    (input)="updateVehicleField(vehicle.id, 'vin', $event)"
                  />
                }
              }
            </div>
            <div class="detail-row">
              <label>BIN</label>
              <span class="colon">:</span>
              @if (!editModeMap[vehicle.id]) {
                <span class="value">{{ vehicle.bin }}</span>
              } @else {
                @if (editedVehicles[vehicle.id]) {
                  <input
                    type="text"
                    class="edit-input"
                    [value]="editedVehicles[vehicle.id].bin"
                    (input)="updateVehicleField(vehicle.id, 'bin', $event)"
                  />
                }
              }
            </div>
            <div class="detail-row">
              <label>Vehicle Number</label>
              <span class="colon">:</span>
              @if (!editModeMap[vehicle.id]) {
                <span class="value">{{ vehicle.vehicleNo }}</span>
              } @else {
                @if (editedVehicles[vehicle.id]) {
                  <input
                    type="text"
                    class="edit-input"
                    [value]="editedVehicles[vehicle.id].vehicleNo"
                    (input)="updateVehicleField(vehicle.id, 'vehicleNo', $event)"
                  />
                }

              }
            </div>
            <div class="button-group">
              @if (vehicle.status === UserStatus.PENDING|| vehicle.status ==UserStatus.REJECTED) {
                <button class="approve-btn" [disabled]="vehicle.status != UserStatus.PENDING || editModeMap[vehicle.id]" (click)="approveVehicle(vehicle.id, i)" >
                  Approve
                </button>
              }
              <button class="reject-btn" [disabled]="vehicle.status === UserStatus.REJECTED || editModeMap[vehicle.id]"  (click)="rejectVehicle(vehicle.id, i)">
                Reject
              </button>
            </div>
          </div>
          <div class="image-section">
            <div class="image-gallery">
              <div class="image-carousel">
                <button class="carousel-btn prev" (click)="previousImage(i)" [disabled]="vehicle.proofImages.length <= 1">
                  <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
                <div class="image-container" [class.zoomed]="isZoomed(i)" (click)="toggleZoom(i)">
                  @if (isZoomed(i)) {
                    <div class="zoom-overlay" (click)="toggleZoom(i)"></div>
                  }
                  <img [src]="getCurrentImage(i)"
                       alt="Vehicle document"
                       [class.zoomed]="isZoomed(i)"
                       [style.transform]="isZoomed(i) ? 'scale(' + getZoomLevel(i) + ')' : 'scale(1)'"/>
                </div>
                <button class="carousel-btn next" (click)="nextImage(i)" [disabled]="vehicle.proofImages.length <= 1">
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
              </div>
              <div class="image-indicator">
                <span>{{ currentImageIndices[i] + 1 }} / {{ vehicle.proofImages.length }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
